export default __webpack_public_path__ + "static/media/availablenetworks.1e5b6f9a.png";